import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import SearchSuggestion from "../pages/searchLanding/SearchSuggestion";

import {
  getSearchResults,
  resetSearchPage,
} from "../containers/searchSlice/searchSlice";
import { MdOutlineSearch, MdClose } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import { checkReplaceUrl } from "../utils";
import { resetFacet } from "../containers/searchLandingSlice";
import SupportSearchSuggestion from "../pages/SearchSupport/SupportSearchSuggestion";

export const SearchInput = ({
  onSearchQueryChange,
  getSuggestionData,
  clearSuggestion,
  page
}) => {
  const { t } = useTranslation();
  let baseurl = "https://www.westerndigital.com";
  const dispatch = useDispatch();
  const divRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const filterBy = []


  useEffect(() => {
    const searchInput = searchParams.get("q") ? searchParams.get("q") : "";

    if (searchInput.length > 1) {
      setSearchQuery(searchInput);
    } else {
      setSearchQuery("");
    }
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setIsOpen(false);
        if(clearSuggestion)
        clearSuggestion();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getSuggestion = async (searchText) => {
    if(getSuggestionData){

      await getSuggestionData(searchText);
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      // setDebouncedQuery(query);
      if (searchText.trim().length > 2) {
        getSuggestion(searchText);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleKeyDown = (event) => {
    const searchQuery = event.target.value;
    // if(searchQuery.length > 1) {
    //   setSearchQuery(searchQuery);
    // }
    // else if(searchQuery.length === 0) {
    //   clearSearchQuery();
    // }
    if (event.key === "Enter") {
      handleSearchQueryChange(searchQuery);
      setIsOpen(false);
    }
  };

  const onInputChange = (e) => {
    const searchQuery = e.target?.value;
    setSearchQuery(searchQuery);
    if (searchQuery.length === 0) {
      clearSearchQuery();
    }
    setSearchText(searchQuery);
    if (searchQuery.trim().length > 2) {
      if(clearSuggestion)
      clearSuggestion();
      setIsOpen(true);
      setLoading(true);
    } else {
      setIsOpen(false);
      if(clearSuggestion)
      clearSuggestion();
    }
  };

  const handleSearchQueryChange = (newSearchQuery) => {
    setSearchQuery(newSearchQuery);
    onSearchQueryChange(newSearchQuery);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    console.log(event, searchQuery);
    if(window.aa.loadAllTags === false){
      window.aa.loadAllTags = true
    }

    if(window.utag_data?.eventName === "PAGE_LOAD"){
      window.utag_data = {
        ...window.utag_data,
        eventName : "PAGE_LOADED",
      }
    }
    if(window.utag_data){
      let totalResults = document.getElementById("totalResults");
      window.utag_data = {
        ...window.utag_data,
        q : searchQuery,
        searchTerm : searchQuery,
        searchTermsCount : totalResults ? totalResults.innerHTML : ""
      }
      setTimeout(() => {
        totalResults = document.getElementById("totalResults");
        window.utag_data = {
          ...window.utag_data,
          searchTermsCount : totalResults ? totalResults.innerHTML : ""
        }
        if(trackInternalSearch){
            trackInternalSearch(searchQuery, totalResults ? totalResults.innerHTML : "", filterBy);
        }
      },2000)
    }

        
    // handleSearchQueryChange(searchQuery);
  };

  function trackInternalSearch(q, numFound, filterBy) {
        var searchObj = {}
        searchObj["q"] = q;
        searchObj["searchTermsCount"] = numFound;
        searchObj["filterBy"] = [];
        searchObj["filterBy"] = filterBy != '' ? decodeURIComponent((filterBy).replace(new RegExp('%22', 'g'), '').split("OR")).split(",") : 'All';
        try {
            var event = window.aa.createEvent("SEARCH", searchObj);
            window.dispatchEvent(event);
        } catch (e) {
            console.log("Error while triggering analytics Search event.");
        }
    }

  const clearSearchQuery = () => {
    document.querySelector(".sd-search").value = "";
    setSearchQuery("");
    setSearchParams({});
    handleSearchQueryChange("");
  };

  const handleSearchClick = (event) => {
    const searchQuery = document.querySelector(".sd-search").value;
    handleSearchQueryChange(searchQuery);
    
  };


  const handleSuggestionClick = (e,searchQuery) =>{
    console.log(e.target.text)
    setSearchQuery(e.target.text)
    handleSearchQueryChange(e.target.text)
    setIsOpen(false)
  }

  return (
    <React.Fragment>
      <div className="sd-col-span-12 sd-grid lg:sd-grid-cols-12 sd-grid-cols-8 sd-gap-4 ">
        <div className="sd-col-span-12 sd-relative">
          <h2 className="sd-uppercase sd-text-[13px] sd-titleText">
            {t("searchBase")}
          </h2>

          <div className="sd-mt-[14px]">
            <div className="sd-flex sd-items-center lg:sd-h-[103px] lg:sd-h-[90px] sd-h-[60px] sd-border sd-rounded-lg sd-border-n-gray-3 sd-font-pilat sd-text-[17px] lg:sd-text-[23px]">
              <button onClick={handleSearchClick}>
                <MdOutlineSearch className="sd-mr-3 sd-ml-[1rem] sd-text-grey-3" />
              </button>
              <form className="sd-flex-grow" onSubmit={handleFormSubmit}>
                <input
                  // defaultValue={searchQuery ?? ""}
                  onKeyDown={handleKeyDown}
                  className="sd-inline-block sd-w-full sd-border-none sd-bg-transparent sd-font-pilat sd-outline-none sd-pr-4 sd-text-grey-300 sd-search"
                  type="text"
                  id=""
                  name="q"
                  autocomplete="off"
                  aria-required="false"
                  placeholder={t("searchPlaeHolder")}
                  onChange={(e) => onInputChange(e)}
                  value={searchQuery}
                />
              </form>
              {searchQuery?.length > 0 && (
                <button onClick={clearSearchQuery} className="sd-ml-auto">
                  <MdClose className="sd-mr-5 sd-ml-[32px]" />
                </button>
              )}
            </div>
            {/* <form action="/submit" method="POST" aria-labelledby="" className="">
                        </form> */}
          </div>
          {page==='search' && 
          <SearchSuggestion isOpen={isOpen} divRef={divRef} loading={loading}   handleSuggestionClick={handleSuggestionClick} searchQuery={searchQuery}/>
          }
          {page==='search_support' && 
          <SupportSearchSuggestion isOpen={isOpen} divRef={divRef} loading={loading}   handleSuggestionClick={handleSuggestionClick} searchQuery={searchQuery}/>
          }
        
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchInput;